import { NavLink, useNavigate } from 'react-router-dom';
import { getToken, isAdmin } from '../utils/auth';

import {
  HomeIcon,
  UserCircleIcon,
  ArrowRightStartOnRectangleIcon
} from '@heroicons/react/24/outline';

export default function Navbar() {
  const navigate = useNavigate();
  const token = getToken();
  const userIsAdmin = isAdmin(token);

  function handleLogout() {
    localStorage.removeItem('token');
    navigate('/login');
  }

  return (
    <div className="navbar bg-base-100">
      <div className="navbar-start">
        <NavLink to="/dashboard" className="flex items-center">
          <img src="/logo.png" alt="Brand Logo" className="h-8 w-auto" />
        </NavLink>
      </div>
      <div className="navbar-center">
        <ul className="menu menu-horizontal bg-base-200 rounded-box mt-6">
          <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `tooltip hover:bg-gray-300 transition-colors ${isActive ? 'bg-gray-300' : ''}`
              }
              data-tip="Dashboard"
              end
            >
              <HomeIcon className="h-5 w-5" />
            </NavLink>
          </li>
          {userIsAdmin && (
            <li>
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  `tooltip hover:bg-gray-300 transition-colors ${isActive ? 'bg-gray-300' : ''}`
                }
                data-tip="Admin"
              >
                <UserCircleIcon className="h-5 w-5" />
              </NavLink>
            </li>
          )}

          <li>
            <button
              onClick={handleLogout}
              className="tooltip hover:bg-gray-300 transition-colors"
              data-tip="Logout"
            >
              <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
            </button>
          </li>
        </ul>
      </div>
      <div className="navbar-end"></div>
    </div>
  );
}
